import { render, staticRenderFns } from "./TypeDocumentUpload.vue?vue&type=template&id=d96820c8&scoped=true"
import script from "./TypeDocumentUpload.vue?vue&type=script&lang=js"
export * from "./TypeDocumentUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96820c8",
  null
  
)

export default component.exports